module.exports = __webpack_public_path__ + "static/img/43.80472ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/43.jpg
// module id = 3rGQ
// module chunks = 1